<mat-chip-set [attr.data-test]="'selected-city-items'">
  <ng-container *ngIf="!!alert?.recipients?.municipals?.cities?.length; else empty">
    <mat-chip *ngFor="let item of alert.recipients.municipals.cities" class="selected chip-text-color-inherit" [removable]="false" 
      [attr.data-test]="'city'" [attr.data-testid]="item.cityName">
      {{item.cityName + ', ' + item.stateCode}}
    </mat-chip>
  </ng-container>
  <ng-template #empty>
    <mat-chip class="empty chip-text-color-inherit" disabled="true">{{ 'None Found' | translate:locale.language }}</mat-chip>
  </ng-template>
</mat-chip-set>
<div *ngFor="let layer of alert?.recipients?.municipals?.sendTo" style="padding-top: 0.5rem;" [attr.data-test]="'municipal-layer'" [attr.data-testid]="layer.Name">
  <strong class="layer-title">{{ layer.Name }}:</strong>
  <span><br> &nbsp; {{ 'RecipientCount' | translate:locale.language }}: {{ getLayerRecipientCount(layer) }}</span>
</div>